/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import { CheckboxField, Tip } from '@insticator/insticator-ui'
import { url } from 'utils/urls'
import { ReactComponent as EmojiAdd } from 'assets/icons/emoji-add.svg'
import { ReactComponent as ImageAdd } from 'assets/icons/image.svg'
import { ReactComponent as GifAdd } from 'assets/icons/gif.svg'
import { ReactComponent as VideoAdd } from 'assets/icons/video.svg'
import { ReactComponent as TextFormat } from 'assets/icons/text-format.svg'
// styles
import injectSheet from 'react-jss'
import styles from './mediacomments_styles'
import Space from 'material/space/space';
import PreviewConfig from '../../previewconfig/previewconfig';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : MEDIA COMMENTS ~~~~~~~~~~ ========== */
const MediaComments = injectSheet(styles)((props) => {

  const { allowLinks, allowRichMedia, allowVideos, allowVimeo, allowYoutube, allowImages, allowGifs, onChange } = props

  return (
    <SectionGroupV2 klass={`mediacomments ${props.classes.mediacomments}`} title={'Rich Media'} description={'Select whether users can add links, images, and videos in their comments.'}>
      <Space gap={32} direction={'column'}>
      <ConfigToggle 
        title={'Allow links'}
        description={'Turn this off to prevent comments from containing links.'}
        checked={allowLinks}
        onChange={val => onChange('allowLinks', val)}
      />
      <ConfigToggle 
        title={'Allow rich media'}
        description={'Turn this off to improve download speed and responsiveness.'}
        checked={allowRichMedia}
        onChange={val => onChange('allowRichMedia', val)}
        gap={16}
      >
        <ConfigToggle 
          title={'Images'}
          checked={allowImages}
          onChange={val => onChange('allowImages', val)}
        />
        <ConfigToggle 
          title={'GIFs'}
          checked={allowGifs}
          onChange={val => onChange('allowGifs', val)}
        />
        <ConfigToggle 
          title={
            <span>
              Videos
              <Tip 
                space={'none'} 
                icon={'question-circle'} 
                content={'Only YouTube and Vimeo players are supported. No other players will work. An invalid URL message will be shown to users.'} 
                label={' '} 
              />
            </span>
          }
          checked={allowVideos && (allowYoutube || allowVimeo)}
          onChange={val => onChange('allowVideos', val, {allowYoutube: val, allowVimeo: val})}
          gap={16}
        >
          <CheckboxField 
            type={`checkbox`} 
            name={`youtube`} 
            value={`youtube`} 
            checked={allowYoutube}
            handleChange={() => onChange('allowYoutube', !allowYoutube)}
            label={`YouTube`} 
          />
          <CheckboxField 
            type={`checkbox`} 
            name={`vimeo`} 
            value={`vimeo`} 
            checked={allowVimeo}
            handleChange={() => onChange('allowVimeo', !allowVimeo)}
            valid
            label={`Vimeo`} 
          />
        </ConfigToggle>

      </ConfigToggle>
      </Space>
      <PreviewConfig>
        <Space klass={'mediacommentspreview'} direction={'column'}>
          <Space klass={'commentbox'} alignItems={'flex-start'} direction={'column'}>
            <div className={'commenttextarea'}>
              <p>{allowLinks ? 'https://wwww.buzzfeed.com/skiing' : ' '}</p>
              {allowRichMedia && 
                <Space alignItems={'center'}>
                {allowImages && <img height={40} src={`${url.image}/2.0/media-comments-1.png`} />}
                {allowGifs && <img height={50} src={`${url.image}/2.0/media-comments-2.png`} />}
                {allowYoutube && allowVideos && <img height={50} src={`${url.image}/2.0/media-comments-3.png`} />}
                {allowVimeo && allowVideos && <img height={50} src={`${url.image}/2.0/media-comments-4.png`} />}
              </Space>
              }
            </div>
            <Space alignItems={'center'} justifiyContent={'space-between'}>
              <Space klass={'commentrichmedia'} alignItems={'center'}>
                <EmojiAdd />
                {allowRichMedia && 
                  <>
                    {allowImages && <ImageAdd />}
                    {allowGifs && <GifAdd />}
                    {allowVideos && <VideoAdd />}
                  </>
                }
                <TextFormat />
              </Space>
              <div className='cancelbutton button'>Cancel</div>
              <div className='postbutton button'>Post</div>
            </Space>
          </Space>
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MediaComments;